import * as http from 'axios'

export const validaSinSaude = (payload) => {
  return http.post('/users/validateSinsaude', payload)
}

export const salvarUsuarioSinSaude = (payload) => {
  return http.post('/users/createUserSinsaude', payload)
}



// WEBPACK FOOTER //
// ./src/store/sinsaude/services.js